import { Components, Theme } from '@mui/material/styles';
import Link from 'next/link';

export const muiLinkOverride: Components<Theme>['MuiLink'] = {
  defaultProps: {
    component: Link,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      textDecoration: 'none',
      cursor: 'pointer',
      transition: theme.transitions.create(['color', 'text-decoration'], {
        duration: theme.transitions.duration.shortest,
      }),
      '&.MuiLink-underlineNone': {
        textDecoration: 'none',
      },

      '&.MuiLink-underlineHover': {
        '&:hover': {
          textDecoration: 'underline',
        },
      },
      '&.MuiLink-underlineAlways': {
        textDecoration: 'underline',
      },
      '&:hover': {
        color: theme.vars.palette.primary.main,
      },

      '&:focus': {
        outlineStyle: 'solid',
        outlineColor: theme.vars.palette.primary.light,
        outlineWidth: 2,
        outlineOffset: 2,
      },

      '&:visited': {
        color: theme.vars.palette.primary.dark,
      },
    }),
  },
};
